import React, { useEffect } from 'react';
import { CreditCard, X, Check, Loader2 } from 'lucide-react';
import Button from '../ui/Button';
import { useCheckPaymentStatusQuery, useGetCurrentUserQuery } from '../../store/services/api';

interface PaymentSuccessProps {
  isOpen: boolean;
  onClose: () => void;
  sessionId?: string;
}

const PaymentSuccess = ({ isOpen, onClose, sessionId }: PaymentSuccessProps) => {
  // Ödeme durumunu kontrol et
  const { data: paymentStatus, isLoading } = useCheckPaymentStatusQuery(
    sessionId || '', 
    { skip: !sessionId || !isOpen }
  );

  // Kullanıcı bilgilerini yenile
  const { refetch: refetchUser } = useGetCurrentUserQuery();

  useEffect(() => {
    if (paymentStatus?.status === 'completed') {
      // Başarılı ödemeden sonra kullanıcı bilgilerini güncelle
      refetchUser();
      
      // Stripe session ID'lerini temizle
      localStorage.removeItem('stripe_pending_session_id');
      localStorage.removeItem('pending_payment_session');
    }
  }, [paymentStatus?.status, refetchUser]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-[2px]"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div 
        className="bg-white rounded-lg w-full max-w-md shadow-lg relative p-6" 
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        
        {isLoading ? (
          <div className="text-center py-8">
            <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-[#FF4444]" />
            <p className="text-gray-600">Verifying payment...</p>
          </div>
        ) : (
          <div className="text-center mb-5">
            <div className="bg-green-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <Check className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900">Payment Successful!</h2>
            <p className="text-gray-600 mt-2">
              Your payment has been processed successfully. Your account has been updated with new credits.
            </p>
          </div>
        )}
        
        <Button
          onClick={onClose}
          className="w-full"
          disabled={isLoading}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

export default PaymentSuccess; 